import React from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import style from './MyhouseReviewDetailContents.module.scss'

import useMediaViewer from '@Hooks/mediaViewer/useMediaViewer'
import useReview from '@Hooks/myhouse/review/useReview'
import { THUMBNAIL } from '@Root/contants'
import { handleNclick } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

const MyhouseReviewDetailContents: React.FC = () => {
  const { review } = useReview()
  const { detail } = review

  const { content, imageList } = detail
  const { useReviewMediaViewer } = useMediaViewer()

  const { open } = useReviewMediaViewer()

  const imageClickHandler = (index: number) => (event: React.SyntheticEvent) => {
    event.preventDefault()
    event.stopPropagation()
    handleNclick(NCLICK.MY_HOUSE.REVIEW_DETAIL.IMAGE_VIEWER, event)

    open(index)
  }

  return (
    <div className={cx('myhouse_resident_detail')}>
      <p className={cx('myhouse_detail_text')}>{content}</p>
      {!!imageList?.length &&
        imageList.map(({ sequence, url }, index) => {
          return (
            <a href="#" className={cx('myhouse_link_image')} key={`notice_image_${sequence}`} onClick={imageClickHandler(index)}>
              <img src={`${url}?${THUMBNAIL.W700}`} alt="공지사항" className={cx('myhouse_detail_image')} />
            </a>
          )
        })}
    </div>
  )
}

export default MyhouseReviewDetailContents
